import { Stack } from "@mui/material";
import { useState } from "react";
import { jobBoardsService } from "@store/jobBoards/jobBoards.service";
import { useTranslation } from "react-i18next";
import AIOButtonComponent from "@components/Button.component";
import AIOTextfieldComponent from "@components/input/AIOTextfield.component";
import { useSnackbar } from "notistack";

interface Props {
  onClose: () => void;
}

const JobBoardWithoutStripeModal = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    information: "",
    link: "",
    type: "",
  });

  const handleSubmit = () => {
    if (!formData.name || !formData.link || !formData.type) {
      enqueueSnackbar(t("adminParameters.jobboardWithoutStripe.error"), { variant: "error" });
      return;
    }

    setIsSubmitting(true);
    jobBoardsService.postJobBoardWithoutStripe(formData).subscribe({
      next: () => {
        enqueueSnackbar("Job board ajouté avec succès", { variant: "success" });
        jobBoardsService.getJobBoards().subscribe();
        onClose();
      },
      error: (error) => {
        console.error("Erreur lors de l'ajout du job board:", error);
        enqueueSnackbar(error.message || "Une erreur est survenue lors de l'ajout du job board", { 
          variant: "error" 
        });
        setIsSubmitting(false);
      }
    });
  };

  return (
    <Stack spacing={3} p={2}>
      <AIOTextfieldComponent
        title={t("adminParameters.jobboardWithoutStripe.name")}
        placeholder={t("adminParameters.jobboardWithoutStripe.name")}
        required
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e })}
      />
      <AIOTextfieldComponent
        title={t("adminParameters.jobboardWithoutStripe.information")}
        placeholder={t("adminParameters.jobboardWithoutStripe.information")}
        value={formData.information}
        onChange={(e) => setFormData({ ...formData, information: e })}
        multiline
        required
        rows={4}
      />
      <AIOTextfieldComponent
        title={t("adminParameters.jobboardWithoutStripe.link")}
        placeholder={t("adminParameters.jobboardWithoutStripe.link")}
        required
        value={formData.link}
        onChange={(e) => setFormData({ ...formData, link: e })}
      />
      <AIOTextfieldComponent
        title={t("adminParameters.jobboardWithoutStripe.type")}
        placeholder={t("adminParameters.jobboardWithoutStripe.type")}
        required
        value={formData.type}
        onChange={(e) => setFormData({ ...formData, type: e })}
      />
      <AIOButtonComponent
        title={t("adminParameters.jobboardWithoutStripe.add")}
        variant="contained"
        color="secondary"
        fullWidth={false}
        onClick={handleSubmit}
        disabled={isSubmitting}
      />
    </Stack>
  );
};

export default JobBoardWithoutStripeModal;
